import { useEffect, type DependencyList } from "react";
import { genieTools, type GenieTool } from "./registries/tool-registry";
import { useIsGenieEnabled } from "./useIsGenieEnabled";

export function useGenieTools(
  buildTools: () => GenieTool[],
  deps: DependencyList,
  extraEnabled = true
): void {
  const enabled = useIsGenieEnabled();
  useEffect(() => {
    if (!enabled || !extraEnabled) return;
    return genieTools.registerMany(buildTools());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, extraEnabled, ...deps]);
}
